import React, { useState } from 'react';
import { Button, Table } from 'reactstrap';

import authorizedFetch, { authorizedPost } from '../api-authorization/AuthorizedFetch';
import WithLoader from '../WithLoader';
import AddUserModal from './modals/AddUserModal';
import { safeParseResponse } from '../../utils';

const StaffPanel = ({ schoolId }) => {
  const [staff, setStaff] = useState([]);
  // todo - do we need reload count like the other components have? i didnt see the setter being used here
  // eric: we do, there is a bug where this list does not refresh when a staff member is added, I have fixed that bug below
  // also, do we need "new" (renamed it to isNewStaff)
  // eric: no, I think this was from an older method of displaying things, similar to how the classes are displayed within a school which I decided was ugly and stupid
  // also, do we need "selectedStaff?"
  // eric: no, again related to the old way of doing it
  // const [selectedStaff, setSelectedStaff] = useState(null);
  // const [isNewStaff, setIsNewStaff] = useState(true);
  const [reloadCount, setReloadCount] = useState(0);

  const [modalState, setModalState] = useState(false);

  const loadStaff = async done => {
    const response = await authorizedFetch(`api/schools/${schoolId}/staff`);
    const { staff } = await safeParseResponse(response) || {};
    setStaff(staff);
    done();
  };

  const staffAdded = () => {
    setReloadCount(reloadCount + 1);
    setModalState(false);
  }
  
  const toggleNewStaff = () => setModalState(!modalState);

  const createStaff = async userCommand => {
    const response = await authorizedPost(`api/schools/${schoolId}/students`, userCommand);
    const { status } = response;

    if(status === 400) {
      return {
        messages: await safeParseResponse(response),
        status
      }
    }

    return { status };
  };

  return (
    <WithLoader key={reloadCount} action={loadStaff}>
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th><Button color='primary' onClick={toggleNewStaff}>New</Button></th>
          </tr>
        </thead>
        <tbody>
          {staff.map(s => (
            <tr key={s?.applicationUserId}>
              <td>{s?.firstName} {s?.lastName}</td>
              <td>{s?.email}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <AddUserModal isOpen={modalState} toggle={toggleNewStaff} role="Teacher" userCreator={createStaff} onAdded={staffAdded} />
    </WithLoader>
  );
}

export default StaffPanel;